import * as yup from 'yup';
import {
  addOptionalToSchema,
  optionalNameSchema,
  requiredErrorMessage,
  stateSchema,
} from '@common/schema';

export const createAdminTeamSchema = yup.object().shape({
  name: yup.string().required(requiredErrorMessage),
  description: optionalNameSchema,
  record_type: yup
    .string()
    .oneOf(['organization', 'partner', 'practice'])
    .required(requiredErrorMessage),
  record_id: yup.string().required(requiredErrorMessage),
  city: optionalNameSchema,
  state: addOptionalToSchema(stateSchema),
});
